import type { CustomControlCode, ServiceCode } from '@common/enums';
import type { IServiceEmployment } from '@frontend/components/interfaces';
import { fetchJson } from '@frontend/store/fetch';

let fetchedServiceEmployments: IServiceEmployment[];

export async function getServiceEmployments(employmentId: string, signal: AbortSignal): Promise<IServiceEmployment[]> {
    if (!fetchedServiceEmployments) {
        const url = `/api/serviceEmployments?employmentId=${employmentId}&includeSettings=true&isActive=true&includeActivityAuthorizations=true`;
        const result = await fetchJson({ method: 'GET', signal, url });

        fetchedServiceEmployments = result.json.items;
    }

    return fetchedServiceEmployments;
}

export async function getHasWriteAuthorizationForCustomControlCode(
    employmentId: string,
    customControlCodes: CustomControlCode[],
    signal: AbortSignal
): Promise<boolean> {
    const serviceEmployments = await getServiceEmployments(employmentId, signal);

    return serviceEmployments.some((serviceEmployment) =>
        serviceEmployment.serviceActivityAuthorizations.some(
            (authorization) =>
                customControlCodes.includes(authorization.serviceActivity.customControlCode) && authorization.canWrite
        )
    );
}

export async function getServiceEmploymentSettings(
    employmentId: string,
    serviceCode: ServiceCode,
    signal: AbortSignal
): Promise<IServiceEmployment['settings'] | undefined> {
    const serviceEmployments = await getServiceEmployments(employmentId, signal);

    return serviceEmployments.find((serviceEmployment) => serviceEmployment.service.code === serviceCode)?.settings;
}
